import React from 'react';
const Bullets = () => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "21", height: "18", fill: "none" },
    React.createElement("path", { stroke: "#000", strokeLinecap: "round", strokeWidth: "3", d: "M7 2h12M7 9h12M7 16h12" }),
    React.createElement("circle", { cx: "1.5", cy: "2", r: "1.5", fill: "#000" }),
    React.createElement("circle", { cx: "1.5", cy: "9", r: "1.5", fill: "#000" }),
    React.createElement("circle", { cx: "1.5", cy: "16", r: "1.5", fill: "#000" })));
export default Bullets;
//# sourceMappingURL=Bullets.js.map